import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';

import { AuthService } from '../auth';

export const canActivateAuth: CanActivateFn = (
    snapshot: ActivatedRouteSnapshot
) => {
    const auth = inject(AuthService);
    if (auth.isLoggedIn()) {
        return true;
    } else {
        auth.setRedirectPath(snapshot.url.join('/'));
        auth.signOut();
        return false;
    }
};
